// The checked-in scorpion is the only artwork source. Its path coordinates,
// yellow bolt count and lettering are preserved. Animation never touches a
// product photograph or a print file.
let sourcePromise;
const NS='http://www.w3.org/2000/svg';
export function splitScorpionPath(d) {
  const index=d.indexOf(' M 452 325');
  return index<0 ? {body:d,tail:''} : {body:d.slice(0,index),tail:d.slice(index+1)};
}
async function source() {
  if(!sourcePromise)sourcePromise=fetch('/brand/scorpion-main.svg').then(r=>{
    if(!r.ok)throw new Error('Brand source unavailable');return r.text();
  }).catch(e=>{sourcePromise=null;throw e;});
  return sourcePromise;
}
export function createBrandMark(mode='entrance') {
  const root=document.createElement('div');root.className=`brand-mark brand-mark--${mode}`;
  root.setAttribute('role','img');root.setAttribute('aria-label','PARALYZE AREA');
  const fallback=document.createElement('img');fallback.src='/brand/scorpion-main.svg';fallback.alt='';fallback.draggable=false;
  root.append(fallback);
  let cancelled=false;
  source().then(text=>{
    if(cancelled)return;
    const parsed=new DOMParser().parseFromString(text,'image/svg+xml');
    const svg=parsed.documentElement;
    if(svg.localName!=='svg'||parsed.querySelector('parsererror'))return;
    const original=svg.querySelector('path[fill="#111111"]');
    if(!original)return;
    const parts=splitScorpionPath(original.getAttribute('d'));
    const mascot=document.createElementNS(NS,'g');mascot.setAttribute('class','brand-mascot');
    const body=original.cloneNode();body.setAttribute('d',parts.body);body.setAttribute('class','brand-body');mascot.append(body);
    if(parts.tail){const tail=original.cloneNode();tail.setAttribute('d',parts.tail);tail.setAttribute('class','brand-tail');mascot.append(tail);}
    original.replaceWith(mascot);
    const bolts=svg.querySelector('path[fill="#FFC400"]');bolts?.setAttribute('class','brand-bolts');
    svg.removeAttribute('role');svg.removeAttribute('aria-label');svg.setAttribute('aria-hidden','true');
    svg.classList.add('brand-mark-svg');
    root.replaceChildren(document.importNode(svg,true));root.dataset.artReady='true';
  }).catch(()=>{/* Keep the original static logo if loading fails. */});
  return {element:root,dispose(){cancelled=true;root.remove();}};
}
